
    import Vue from 'vue';
    export default Vue.extend({
        name: 'NotFound',
        data() {
            return {

            }
        },
        mounted() {
            NF.UI.Page.unblock();
            sessionStorage.setItem("ExitOrContinueModal", "false");
        }
    });
